/**
 * Map Overall Delivery Status Function.
 * @param resources - Object with translation keys.
 * @returns getter functions for text and code.
 */
export const mapOverallDeliveryStatus = (resources: any) => {
    const map = new Map<string, string>([
        ['00', resources.globalStatusOverallUnknown],
        ['05', resources.globalStatusOverallQueued],
        ['10', resources.globalStatusOverallRequested],
        ['20', resources.globalStatusOverallCanceled],
        ['30', resources.globalStatusOverallConfirmed],
        ['50', resources.globalStatusOverallPartiallyDispatched],
        ['70', resources.globalStatusOverallGoodsDispatched],
        ['80', resources.globalStatusOverallPartiallyReceived],
        ['90', resources.globalStatusOverallCompleted]
    ]);

    const getCodeExists = (code: string): boolean => map.has(code);

    const getText = (code: string): string => map.get(code) ?? resources.globalStatusError;

    const getCode = (text: string): string => {
        for (const [key, value] of map.entries()) {
            if (value === text) {
                return key;
            }
        }
        return '';
    };

    return { getCodeExists, getText, getCode };
};

/**
 * Map Overall Invoice Status Function.
 * @param resources - Object with translation keys.
 * @returns getter functions for text and code.
 */
export const mapOverallInvoiceStatus = (resources: any) => {
    const map = new Map<string, string>([
        ['00', resources.globalInvoiceStatusOverallUnknown],
        ['20', resources.globalInvoiceStatusOverallCanceled],
        ['30', resources.globalInvoiceStatusOverallPending],
        ['60', resources.globalInvoiceStatusOverallPartiallyInvoiced],
        ['80', resources.globalInvoiceStatusOverallInvoiced]
    ]);

    const getCodeExists = (code: string): boolean => map.has(code);

    const getText = (code: string): string => map.get(code) ?? resources.globalStatusError;

    const getCode = (text: string): string => {
        for (const [key, value] of map.entries()) {
            if (value === text) {
                return key;
            }
        }
        return '';
    };

    return { getCodeExists, getText, getCode };
};

/**
 * Delivery status code → description text.
 */
export const mapOverallDeliveryStatusCodeDescriptionToText = (code: string, resources: any): string => {
    switch (code) {
        case '00':
            return resources.globalStatusOrderUnknownDescription;
        case '05':
            return resources.globalStatusOrderQueuedDescription;
        case '10':
            return resources.globalStatusOrderRequestedDescription;
        case '20':
            return resources.globalStatusOrderCanceledDescription;
        case '30':
            return resources.globalStatusOrderConfirmedDescription;
        case '50':
            return resources.globalStatusOrderPartiallyDispatchedDescription;
        case '70':
            return resources.globalStatusOrderGoodsDispatchedDescription;
        case '80':
            return resources.globalStatusOrderPartiallyReceivedDescription;
        case '90':
            return resources.globalStatusOrderCompletedDescription;
        default:
            return resources.globalStatusErrorDescription;
    }
};

/**
 * Invoice status code → description text.
 */
export const mapOverallInvoiceStatusCodeDescriptionToText = (code: string, resources: any): string => {
    switch (code) {
        case '00':
            return resources.globalInvoiceStatusOverallUnknownDescription;
        case '20':
            return resources.globalInvoiceStatusOverallCanceledDescription;
        case '30':
            return resources.globalInvoiceStatusOverallPendingDescription;
        case '60':
            return resources.globalInvoiceStatusOverallPartiallyInvoicedDescription;
        case '80':
            return resources.globalInvoiceStatusOverallInvoicedDescription;
        default:
            return resources.globalStatusErrorDescription;
    }
};
